import React from "react";
import Button from "@mui/material/Button";
import { color, padding, styled } from "@mui/system";
import "../../../css/utility.scss";
import CircularProgress from "@mui/material/CircularProgress";

// Prevent 'customcolor' from being passed to the DOM
const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "customcolor",
})(({ customcolor }) => {
  const baseStyles = {
    borderRadius: "10px",
    textTransform: "none",
    margin: "0",
    padding: "8px 16px",
  };

  const variantStyles = {
    primary: {
      backgroundColor: "#154D8F",
      color: "#fff",
      "&:hover": { backgroundColor: "#336094ff" },
    },
    gray: {
      backgroundColor: "#717680",
      color: "#fff",
      "&:hover": { backgroundColor: "#5e5f66" },
    },
    default: {
      backgroundColor: "white",
      color: "black",
      "&:hover": { backgroundColor: "#5e5f66" , color:'white' },
    },
    danger: {
      backgroundColor: "#d32f2f",
      color: "#fff",
      "&:hover": { backgroundColor: "#b71c1c" },
    },
    success: {
      backgroundColor: "#2e7d32",
      color: "#fff",
      "&:hover": { backgroundColor: "#1b5e20" },
    },
    warning: {
      backgroundColor: "#ed6c02",
      color: "#fff",
      "&:hover": { backgroundColor: "#e65100" },
    },
    orange: {
      backgroundColor: "#F04438",
      color: "#fff",
      "&:hover": { backgroundColor: "#cc544bff" },
    },
    "outline-gray": {
      backgroundColor: "transparent",
      border: "1px solid #717680",
      color: "#717680",
      "&:hover": {
        backgroundColor: "#f0f0f0",
        borderColor: "#5e5f66",
        color: "#5e5f66",
      },
    },
  };

  return {
    ...baseStyles,
    ...(variantStyles[customcolor] || {}),
  };
});

export default function Buttons(props) {
  const {
    text,
    size,
    colors, // 'primary', 'secondary', 'gray', etc.
    variant,
    onClick,
    startIcon,
    type,
    disabled,
    loading,
    ...other
  } = props;

  const isCustomColor = [
    "gray",
    "danger",
    "success",
    "orange",
    "warning",
    "outline-gray",
    "default",
  ].includes(colors);

  return (
    <StyledButton
      variant={isCustomColor ? "contained" : variant}
      size={size}
      color={!isCustomColor ? colors : undefined}
      onClick={!loading ? onClick : undefined}
      startIcon={startIcon}
      type={type}
      disabled={disabled}
      customcolor={colors}
      {...other}
    >
       {loading ? (
        <CircularProgress size={20} color="inherit" />
      ) : (
        text
      )}
    </StyledButton>
  );
}

// Default props
Buttons.defaultProps = {
  variant: "contained",
  colors: "primary",
  size: "medium",
  text: "Button",
  type: "button",
  disabled: false,
};
